import React  from 'react';
import UserComponentProto from './user-proto.jsx';


export default function renderDateInFormNew(id, props) {
    return <UserComponentProto renderMode="form-new" id={id} {...props} />;
}